exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-29e44d0f],.v-dialog .v-card__text[data-v-29e44d0f]{padding:0!important}.v-dialog .v-alert[data-v-29e44d0f]{border-radius:0!important}.v-dialog[data-v-29e44d0f],.v-dialog .v-card__text[data-v-29e44d0f]{overflow:hidden!important}.v-card__actions[data-v-29e44d0f]{justify-content:flex-end}.confirm-text[data-v-29e44d0f]{font-size:16px}", ""]);

// exports
